import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { spacingPx, theme } from '@moonpig/launchpad-theme'
import { FormattedLocation } from './FormattedLocations'
import { PostcodesGroupedByCity } from '../groupPostcodesByCity'

const StyledList = styled.ul`
  list-style: disc;
  margin-left: ${spacingPx(7)({ theme })};

  li {
    padding-left: ${spacingPx(4)({ theme })};
  }
`

export const BulletedLocationListItem: FC<{
  postcodesByCity: PostcodesGroupedByCity
}> = ({ postcodesByCity }) => {
  return (
    <StyledList>
      {Object.entries(postcodesByCity).map(([city, postcodes]) => {
        return (
          <li key={city}>
            <FormattedLocation city={city} postcodes={postcodes} />
          </li>
        )
      })}
    </StyledList>
  )
}
